import { useEffect, useRef } from "react";

/**
 * useOutClick - Detects clicks outside a specified element.
 *
 * @param {Function} onOutsideClick - Callback to trigger when a click outside occurs.
 */
const useOutClick = (onOutsideClick) => {
	const ref = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				onOutsideClick?.();
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [onOutsideClick]);

	return ref;
};

export default useOutClick;
